import { createSlice } from '@reduxjs/toolkit';
import { validationProduct } from '../actions/ValidationProductActions';

const validationProductSlice = createSlice({
  name: 'validationProduct',
  initialState: {
    getStatus: 'idle',
    status: false,
    messages: '',
    innerMessage: '',
    extraOptions: [],
  },
  reducers: {
    resetPost(state) {
      state.getStatus = 'idle';
      state.status = false;
      state.messages = '';
      state.innerMessage = '';
      state.extraOptions = [];
    },
  },
  extraReducers: {
    [validationProduct.pending]: (state) => {
      state.getStatus = 'loading';
    },
    [validationProduct.rejected]: (state) => {
      state.getStatus = 'error';
    },
    [validationProduct.fulfilled]: (state, action) => {
      state.getStatus = 'succeded';
      state.messages = action?.payload?.msg || '';
      state.innerMessage = action?.payload?.message || '';
      state.status = action?.payload.status || false;
      state.extraOptions = action?.payload.extra_options || [];
    },
  },
});

export const { resetPost } = validationProductSlice.actions;
export default validationProductSlice.reducer;
